const success = {
    backgroundColor: '#E6F6E7',
    border: 2,
    borderColor: '#1C7D26',
};
const error = {
    backgroundColor: '#FDF3F2',
    border: 2,
    borderColor: '#AB1212',
};
export default {
    success,
    error,
};
